/* eslint-disable import/prefer-default-export */

export function getErrorMessage(error) {
  const defaultMessage = 'Something went wrong. Please try again.'

  if (!error) return defaultMessage

  return error.message || error.responseJSON?.message || defaultMessage
}
